import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import type { ReactNode } from "react";
import { useCanvasToolbarLayout } from "./CanvasToolbarLayoutContext";

export interface CanvasToolbarFlyoutAnchorProps {
  open: boolean;
  /** Single source of truth for open/close — trigger click, outside click, Escape. */
  onOpenChange?: (open: boolean) => void;
  /** Toolbar control that toggles the flyout. */
  trigger: ReactNode;
  /** Flyout body — typically `CanvasToolbarShell` and groups. */
  children: ReactNode;
}

/**
 * Positions a Type-1 toolbar shell flyout beside its trigger via shadcn Popover.
 * Single source for submenu gap/anchor — Shapes, Note/Doc, Widgets, and similar primary flyouts.
 */
export function CanvasToolbarFlyoutAnchor({
  open,
  onOpenChange,
  trigger,
  children,
}: CanvasToolbarFlyoutAnchorProps) {
  const { menuSide, submenuGapPx } = useCanvasToolbarLayout();

  return (
    <Popover open={open} onOpenChange={onOpenChange}>
      <PopoverTrigger asChild>{trigger}</PopoverTrigger>
      <PopoverContent
        className="w-auto border-0 bg-transparent p-0 shadow-none"
        align="center"
        side={menuSide}
        sideOffset={submenuGapPx}
        onPointerDown={(e) => e.stopPropagation()}
        onClick={(e) => e.stopPropagation()}
        data-canvas-control
      >
        {children}
      </PopoverContent>
    </Popover>
  );
}
